import Vue from 'vue';
import { Component, Inject, Emit, Prop } from 'vue-property-decorator';
import vuejsDatepicker from 'vuejs-datepicker';
import { namespace } from 'vuex-class';

import { Project, LoadProjectOptions } from '@/types/store-types';
import Language from '@/models/datepicker-language';

const project = namespace('project');

@Component({ components: { vuejsDatepicker } })
export default class ChangePeriodModal extends Vue {
  private nl = new Language(
    'Dutch',
    ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
    ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za']);

  private start: Date = new Date();
  private end: Date = new Date();

  @project.Getter('project')
  private project: Project;

  @Prop()
  private startDate: Date;

  @Prop()
  private endDate: Date;

  @project.Action('loadProject')
  private async LoadProject(options: LoadProjectOptions) {
  }

  private setValues() {
    this.start = this.startDate;
    this.end = this.endDate;
  }

  private async saveDate() {
    await this.LoadProject({
      projectId: this.project.projectId,
      startDate: this.start,
      endDate: this.end,
    });
  }
}
